﻿import { ReactNode } from 'react';

import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { merge } from 'utils';

import 'pages/orders/fulfillment_manager/components/Table/styles/Table.scss';

interface TableProps<T> {
	className?: string
	data: T[];
	header?: string;
	loading: boolean;
	noDataMessage: ReactNode;
	onRowClick?: (rowData: T) => void;
	onRowDataMap: (currentRowData: T) => {
		cells: ReactNode[];
		key: number | string;
	}
	tableHeaders: ReactNode[];
}

export function Table<T>(props: TableProps<T>){

    const { className, data, loading, noDataMessage, onRowClick, onRowDataMap, tableHeaders } = props;

    return (
        <div className={merge('table', loading && 'is-loading', data.length === 0 && 'is-empty', className)}>
            {loading
                ? <GMetrixLoader/>
                : data.length > 0
                    ? (
                        <table className="table--element">
                            <thead>
                                <tr>
                                    {tableHeaders.map((tableHeader, i) => (
                                        <th className="table--th" key={i}>
                                            {tableHeader}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map(row => {

                                    const rowInfo = onRowDataMap(row);
                                    return (
                                        <tr
                                            className="table--tr"
                                            key={rowInfo.key}
                                            onClick={() => onRowClick?.(row)}
                                            tabIndex={onRowClick ? 0 : undefined}
                                        >
                                            {rowInfo.cells.map((cell, i) => (
                                                <td className="table--td" key={i}>
                                                    {cell}
                                                </td>
                                            ))}
                                        </tr>
                                    );

                                })}
                            </tbody>
                        </table>
                    )
                    : noDataMessage
            }
        </div>
    );

}